import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DayService {
  private daySource = new BehaviorSubject<string | null>(null);
  currentDay = this.daySource.asObservable();

  constructor() { }

  changeDay(day: string | null) {
    this.daySource.next(day);
  }
}
